import { useState } from 'react'

export default function useToggle(initialValue = false) {
  const [value, setValue] = useState(initialValue)

  function toggle() {
    setValue(val => !val)
  }

  return {
    value,
    toggle
  }
}
